import React, { useMemo, useState } from 'react';
import './css/index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import moment from 'moment';
import styles from './css/index.module.scss';
import TableCell from '../../../../components/TableCell';
import DotsIcon from '../../../../assets/formIcons/dots.svg';
import BlockIcon from '../../../../assets/formIcons/block.svg';
import RefreshIcon from '../../../../assets/formIcons/refresh.svg';
import ChangeUserIcon from '../../../../assets/formIcons/changeUser.svg';
import LikeGrayIcon from '../../../../assets/formIcons/likeGray.svg';
import LikeWhiteIcon from '../../../../assets/formIcons/likeWhite.svg';
import DeleteIcon from '../../../../assets/formIcons/delete.svg';
import ChangeOrgIcon from '../../../../assets/formIcons/changeOrg.svg';
import ChangePhotosIcon from '../../../../assets/formIcons/photosSmall.svg';
import CheckBoxIcon from '../../../../assets/formIcons/checkbox.svg';
import StarIcon from '../../../../assets/formIcons/star.svg';
import TableRow from '../../../../components/TableRow';
import useComponentVisible from '../../../../helpers/hooks/useComponentVisible';
import { ORGANIZATION_MODAL_STATES } from '../../constants';
import Api from '../../../../Api';
import MyCheckBox from '../../../../components/MyCheckbox';
import sendRequest from '../../../../helpers/sendRequest';
import { updateOrganizations } from '../../../../store/actions/organizations';

function OrganizationItem({
  item, itemsPassed, widths, index, setSelectedOrganization, setModalState, setIsModalVisible, withCheckbox, isSelected, setSelected,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { profile } = useSelector((store) => store.account);
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const [approveLoading, setApproveLoading] = useState(false);

  const shouldShowDots = useMemo(() => profile?.access_codes?.includes('canEditOrgs') || (profile?.access_codes?.includes('canEditOnlyOwnOrgs') && item.creator_admin === profile?._id)
        || profile?.access_codes?.includes('modifyUsersAndOrgs') || profile?.access_codes?.includes('canFullyDelete') || profile?.access_codes?.includes('editApproved'), [profile, item.creator_admin]);

  const onOrgClick = (el) => {
    window.open(`/organizations/single-view?id=${el._id}`, '_blank');
  };

  const onPopupItemClick = (state) => (ev) => {
    ev.stopPropagation();
    setSelectedOrganization(item);
    setModalState(state);
    setIsModalVisible(true);
    setIsComponentVisible(false);
  };

  const onSelectFirstClick = () => {
    setSelected([item._id]);
    setIsComponentVisible(false);
  };

  const onEditClick = (el) => (ev) => {
    ev.stopPropagation();
    // navigate(`/organizations/edit?id=${el._id}`);
    window.open(`/organizations/edit?id=${el._id}`, '_blank');
  };

  const onEditPhotosClick = (el) => (ev) => {
    ev.stopPropagation();
    // navigate(`/organizations/edit-photos?id=${el._id}`);
    window.open(`/organizations/edit-photos?id=${el._id}`, '_blank');
  };

  const onCheckBoxClick = () => {
    setSelected((prev) => (!isSelected ? [...prev, item._id] : prev.filter((i) => i !== item._id)));
  };

  const onApproveClick = async (ev) => {
    ev.stopPropagation();
    setIsComponentVisible(false);
    const data = await sendRequest({
      request: Api.approveOrganizations,
      payload: { organization_id: item._id },
      warnErrorText: 'while approving organization',
      setLoading: setApproveLoading,
    });
    if (data?.status === 'ok' && data?.organizations) {
      dispatch(updateOrganizations(data.organizations));
    }
  };

  const onUnapproveClick = async (ev) => {
    ev.stopPropagation();
    setIsComponentVisible(false);
    const data = await sendRequest({
      request: Api.unapproveOrganizations,
      payload: { organization_id: item._id },
      warnErrorText: 'while unapproving organization',
      setLoading: setApproveLoading,
    });
    if (data?.status === 'ok' && data?.organizations) {
      dispatch(updateOrganizations(data.organizations));
    }
  };

  return (
    <div
      // onClick={() => onOrgClick(item)}
      className={classNames(styles.item, { [styles.dashed]: !item.is_active })}
      key={item._id}
    >
      <div className={styles.top}>
        <div className={styles.topLeft} onClick={() => onOrgClick(item)}>
          <img className={styles.photo} src={Api.url + item.carousel_photos[0]?.preview_url} alt="Photo" />
        </div>
        <div className={styles.topMiddle}>
          <p className={styles.title}>
            {item.name}
          </p>
          <div>
            <p className={styles.text}>{item.country.name}</p>
            <div style={{ height: '10px' }} />
            <p className={styles.textGrey}>
              {item.is_in_all_cities_of_country ? 'Все города' : (item.city?.name || '')}
            </p>
          </div>
        </div>
        <div className={styles.topRight}>
          <div style={{
            display: 'flex', gap: '20px', alignItems: 'center',
          }}
          >
            {item.is_approved && (
            <div className={styles.approvedBadge}>
              <img src={LikeWhiteIcon} alt="like" />
              <p className={styles.approvedBadgeText}>Проверено</p>
            </div>
            )}
            {withCheckbox ? (
              <MyCheckBox value={isSelected} onClick={onCheckBoxClick} />
            ) : shouldShowDots ? (
              <TableCell
                isIcon
                onClick={(ev) => {
                  ev.stopPropagation();
                  setIsComponentVisible(true);
                }}
              >
                <img src={DotsIcon} alt=":" />
              </TableCell>
            ) : <div />}
          </div>
          <p className={styles.text}>{moment(item.createdAt).format('DD/MM/YYYY')}</p>
          <p className={styles.textGrey}>
            ID ORG:
            {' '}
            {item._id}
          </p>
        </div>
      </div>

      <div className={styles.bottom}>
        <div className={styles.bottomLeft}>
          <p className={styles.text}>{item.category.name}</p>
          <p className={styles.text}>{item.sub_categories.map((i) => i.name).join(', ')}</p>
          <p className={styles.text}>{item.specialization}</p>
        </div>
        <div className={styles.bottomRight}>
          <p className={styles.text}>{item.user.email}</p>
          <p className={styles.text}>{moment(item.user.createdAt).format('DD/MM/YYYY')}</p>
          <p className={styles.textGrey}>
            ID OWN:
            {' '}
            {item.user._id}
          </p>
        </div>
      </div>

      <div ref={ref} className={`table_popup ${isComponentVisible && 'visible'}`}>
        <div className="table_popup_item" onClick={onSelectFirstClick}>
          <img src={CheckBoxIcon} alt="" />
          <p>Выбрать</p>
        </div>
        {profile?.access_codes?.includes('modifyUsersAndOrgs') && (
          item.is_active ? (
            <div className="table_popup_item" onClick={onPopupItemClick(ORGANIZATION_MODAL_STATES.block)}>
              <img src={BlockIcon} alt="" />
              <p>Забанить предложение</p>
            </div>
          ) : (
            <div className="table_popup_item" onClick={onPopupItemClick(ORGANIZATION_MODAL_STATES.makeActive)}>
              <img src={RefreshIcon} alt="" />
              <p>Разбанить предложение</p>
            </div>
          )
        )}
        {(profile?.access_codes?.includes('canEditOrgs') || (profile?.access_codes?.includes('canEditOnlyOwnOrgs') && item.creator_admin === profile?._id)) && (
          <>
            <div className="table_popup_item" onClick={onEditClick(item)}>
              <img src={ChangeOrgIcon} alt="" />
              <p>Изменить данные</p>
            </div>
            <div className="table_popup_item" onClick={onEditPhotosClick(item)}>
              <img src={ChangePhotosIcon} alt="" />
              <p>Изменить фото</p>
            </div>
          </>
        )}
        {profile?.access_codes?.includes('modifyUsersAndOrgs') && (
          <div className="table_popup_item" onClick={onPopupItemClick(ORGANIZATION_MODAL_STATES.changeOwner)}>
            <img src={ChangeUserIcon} alt="" />
            <p>Изменить владельца</p>
          </div>
        )}
        {profile?.access_codes?.includes('canFullyDelete') && (
          <div className="table_popup_item" onClick={onPopupItemClick(ORGANIZATION_MODAL_STATES.fullyDelete)}>
            <img src={DeleteIcon} alt="" />
            <p>Удалить полностью</p>
          </div>
        )}
        {profile?.access_codes?.includes('editApproved') && (
          item.is_approved ? (
            <div className="table_popup_item" onClick={onUnapproveClick} style={{ opacity: approveLoading ? 0.6 : 1 }}>
              <img src={LikeGrayIcon} alt="" />
              <p>Убрать «Проверено»</p>
            </div>
          ) : (
            <div className="table_popup_item" onClick={onApproveClick} style={{ opacity: approveLoading ? 0.6 : 1 }}>
              <img src={LikeGrayIcon} alt="" />
              <p>Пометить «Проверено»</p>
            </div>
          )
        )}
      </div>
    </div>
  /* <TableRow key={item._id} dashed={!item.is_active}>
                      <TableCell width={widths[0]}>{itemsPassed + index + 1}</TableCell>
                      <TableCell width={widths[1]}>{item.name}</TableCell>
                      <TableCell width={widths[2]}>{item._id}</TableCell>
                      <TableCell width={widths[3]}>{item.user}</TableCell>
                      {shouldShowDots && (
                        <TableCell
                          width={widths[4]}
                          isIcon
                          onClick={() => setIsComponentVisible(true)}
                        >
                          <img src={DotsIcon} alt="" />
                        </TableCell>
                      )}

                    </TableRow> */
  );
}

export default OrganizationItem;
